import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import { SERVER_URL } from '../constants';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import dayjs from 'dayjs';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Box from '@mui/material/Box';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));
  
  
function ScheduleCreate (props) {

    const [open, setOpen] = React.useState(true);

    const [processing, setProcessing] = useState(false);

    const [errorProcessing, setErrorProcessing] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        // if (reason !== 'backdropClick') {
        //     setOpen(false)
        // }
        props.setNewScheduleData();
    };   

    const handleConfirm = () => {
        createSchedule();
    }

    const createSchedule= () => {
        setProcessing(true);
        const token = sessionStorage.getItem("token");
        // console.log("props.newScheduleData", props.newScheduleData);
        fetch(SERVER_URL + 'api/mod/create-schedule',
        {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify(props.newScheduleData)
        })
        .then(response => response.json())
        .then(data => {
            console.log("data", data);
            if (data.status == 1) {
                handleClose();
                setProcessing(false);
                if (typeof props.fetchOffices === 'function') {
                    props.fetchOffices();
                }
                if (typeof props.fetchSchedulesList === 'function') {
                    props.fetchSchedulesList(dayjs(props.rawDate), true);
                }
                if (typeof props.handleClose === 'function') {
                    props.handleClose();
                }
            } else {
                setProcessing(false);
                setErrorProcessing(true);
            }
        })
        .catch((err) => {
            console.error(err);
            setProcessing(false);
        });
    }

    const [type, setType] = React.useState(1);

    const handleChange = (event) => {
        setType(event.target.value);
        props.setNewScheduleData((prev) => ({
            ...prev,
            ...{"type": event.target.value}
        }));
    };


    return(
        <React.Fragment>
            <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="flex-start"
                    spacing={0}
                    >
                        <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                        Create New Schedule
                        </Typography>
                        <Typography variant="body1">
                        {props.scheduleDate}<br />{props.officeName}
                        </Typography>
                    </Stack>
                </DialogTitle>
            
                <DialogContent sx={{ m: 0, p: 0 }} dividers>
                    { errorProcessing ? 
                        <Alert severity="error">Error encountered while trying to create schedule.</Alert>
                        :
                        null
                    }

                    <Box mb={2}>
                        <Typography variant="body1">
                            Would you like to create a new schedule for <b>{props.scheduleDate}</b>?
                        </Typography>
                    </Box>

                    <Box mb={1.5}>
                        <Typography variant="body1">
                            <b>Select Schedule Type</b>
                        </Typography>
                    </Box>

                    <FormControl>
                        <RadioGroup name="type" value={type} onChange={handleChange}>
                            <FormControlLabel
                            value={1}
                            control={<Radio />}
                            sx={{ mb: 2 }} // adds spacing below this option
                            label={
                                <Box display="flex" flexDirection="column">
                                <Typography variant="body1" fontWeight="bold">
                                    Dynamic Queue
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    A numbered queue automatically managed by the system
                                </Typography>
                                </Box>
                            }
                            />
                            <FormControlLabel
                            value={2}
                            control={<Radio />}
                            label={
                                <Box display="flex" flexDirection="column">
                                <Typography variant="body1" fontWeight="bold">
                                    Fixed Schedule
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    You create fixed time slots that clients can choose from
                                </Typography>
                                </Box>
                            }
                            />
                        </RadioGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    { processing ? <CircularProgress size="2rem" /> : null }
                    <Button disabled={processing} onClick={handleConfirm}><CheckIcon fontSize='large' />
                        Create Schedule
                    </Button>
                    <Button disabled={processing} autoFocus onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default ScheduleCreate;